import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';

import { ReduxFormField } from 'components';

class renderField extends PureComponent {
  constructor(props) {
    super(props);
    this.oldValuePass = '';
  }

  componentWillReceiveProps(nextProps) {
    const { input, valuePass } = nextProps;

    if (typeof valuePass !== 'undefined' && this.oldValuePass !== valuePass) {
      input.onChange(valuePass);
      this.oldValuePass = valuePass;
    }
  }

  render() {
    const { input, meta, validate, warn, refPass, valuePass, ...rest } = this.props;

    return (
      <input
        ref={refPass}
        name={input.name}
        value={input.value || valuePass}
        type="hidden"
        {...rest}
        onChange={(e, data) => {
          input.onChange(data.value);
        }}
        onBlur={() => {
          input.onBlur();
        }}
      />
    );
  }
}

const ReduxFormHiddenRecord = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormHiddenRecord.propTypes = {
  input: PropTypes.object
};
ReduxFormHiddenRecord.defaultProps = {};

export default ReduxFormHiddenRecord;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormHiddenRecord.js